/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Start_WorkoutInputs */

const en_us2_today_start_workout = /** @type {(inputs: Today_Start_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start workout`)
};

const pt_br2_today_start_workout = /** @type {(inputs: Today_Start_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar treino`)
};

const es_419_today_start_workout = /** @type {(inputs: Today_Start_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar entrenamiento`)
};

const pt_pt2_today_start_workout = /** @type {(inputs: Today_Start_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar treino`)
};

const fr_fr2_today_start_workout = /** @type {(inputs: Today_Start_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer la séance`)
};

const de_de2_today_start_workout = /** @type {(inputs: Today_Start_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training starten`)
};

const it_it2_today_start_workout = /** @type {(inputs: Today_Start_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia allenamento`)
};

/**
* | output |
* | --- |
* | "Start workout" |
*
* @param {Today_Start_WorkoutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_start_workout = /** @type {((inputs?: Today_Start_WorkoutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Start_WorkoutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_start_workout(inputs)
	if (locale === "es-419") return es_419_today_start_workout(inputs)
	if (locale === "pt-PT") return pt_pt2_today_start_workout(inputs)
	if (locale === "fr-FR") return fr_fr2_today_start_workout(inputs)
	if (locale === "de-DE") return de_de2_today_start_workout(inputs)
	if (locale === "it-IT") return it_it2_today_start_workout(inputs)
	return en_us2_today_start_workout(inputs)
});
export { today_start_workout as "today.start_workout" }